import { createRouter, createWebHashHistory } from 'vue-router'

const isBSystem = () => window.location.hostname.includes('yizhirong-b')

const routes = [
  {
    path: '/',
    redirect: '/form'
  },
  {
    path: '/form',
    name: 'Form',
    component: () => import('../views/FormView.vue')
  },
  {
    path: '/result',
    name: 'Result',
    component: () => import('../views/ResultView.vue')
  },
  {
    path: '/full',
    name: 'ResultFull',
    component: () => import('../views/ResultViewFull.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/AdminView.vue')
  },
  {
    path: '/activate/:token',
    name: 'Activate',
    component: () => import('../views/ActivateView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// ========== B系统路由守卫（修复版：删除旧前端假鉴权）==========
router.beforeEach((to, from, next) => {
  // A系统正常放行
  if (!isBSystem()) {
    next()
    return
  }

  // B系统：有token → 放行（客户专属链接）
  const token = to.query.token || new URLSearchParams(window.location.search).get('token')
  if (token) {
    // 有token时，/form 和 /result 统一重定向到 /full
    if (to.path === '/form' || to.path === '/result') {
      next({ path: '/full', query: { token } })
      return
    }
    next()
    return
  }

  // B系统：无token时，只允许访问 /login 和 /activate
  const allowedPaths = ['/login', '/activate']
  if (allowedPaths.includes(to.path) || to.path.startsWith('/activate/')) {
    next()
    return
  }

  // 无token访问其他路径（如 /admin）→ 直接赶回A系统
  // 管理后台的真正鉴权由 AdminView.vue 的 JWT 校验完成
  window.location.replace('https://yizhirong-a.pages.dev')
})

export default router
